import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SetOfColumns } from '../component/dialog/column-settings-dialog/set-of-columns';
import { RestService } from './rest.service';
import { plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
import { ResourceUUIDVersionIdentifier } from 'src/app/common/model/resource-id-version-identifier';

@Injectable({
    providedIn: 'root'
})
export class SetOfColumnsService extends RestService {

    private readonly baseUrl = 'api/set-of-columns';

    getByDataType(datasource: string): Observable<SetOfColumns[]> {
        return this.doGet(`${this.baseUrl}/datasource/${datasource}`).pipe(
            map((v: SetOfColumns[]) => plainToClass(SetOfColumns, v))
        );
    }

    save(set: SetOfColumsSaveDto): Observable<HttpEvent<HttpEventType>> {
        return this.doPostWithOptions(`${this.baseUrl}`, set, { observe: 'response', reportProgress: false });
    }

    update(id: ResourceUUIDVersionIdentifier, set: SetOfColumsSaveDto): Observable<void> {
        return this.doPut(`${this.baseUrl}/${id}`, set);
    }

    delete(id: ResourceUUIDVersionIdentifier): Observable<HttpEvent<void>> {
        return this.doDelete(`${this.baseUrl}/${id}`);
    }

}

export interface SetOfColumsSaveDto {
    name: string;
    type: string;
    datasource: string;
    fields: string[];
}
